import { TextSelection, } from 'prosemirror-state';
import { GapCursor } from '../gapcursor/index.js';
export const tailGapcursorBackspace = (state, dispatch) => {
    const { selection } = state;
    if (!(selection instanceof GapCursor)) {
        return false;
    }
    const { from, $from } = selection;
    if (from !== state.doc.nodeSize - 2) {
        return false;
    }
    const newSelection = TextSelection.between($from, $from, -1);
    if (!(newSelection instanceof TextSelection)) {
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(state.tr.setSelection(newSelection));
    return true;
};
//# sourceMappingURL=tailGapcursorBackspace.js.map